import { publicApi } from './http';

export const fetchPublicArticles = (params = {}) => publicApi.get('/articles', { params });

export const fetchPublicArticleDetail = (id) => publicApi.get(`/articles/${id}`);
